import { startTransition, useEffect, useState } from 'react'

/**
 * Can be used in case the browser should switch state
 * after mounting a component only in the browser. This
 * is mostly relevant to allow react.hydrate to render
 * the JS as quickly as possible without errors and afterwards
 * switch UI due to some state in the client
 */
export const useDisplayBrowserState = () => {
  const [isBrowser, setIsBrowser] = useState(false)
  useEffect(() => {
    startTransition(() => {
      setIsBrowser(true)
    })
  }, [])
  return isBrowser
}
